import { useContext, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';

import ApiErrorList from './components/common/error/ApiErrorList';
import { AppContext } from './context/app';
import { initRouter } from './pages/router';
import Loading from 'src/components/common/Loading';

function App() {
  const [{ loading }] = useContext(AppContext);
  const [router, setRouter] = useState<Awaited<ReturnType<typeof initRouter>> | null>(null);

  useEffect(() => {
    initRouter().then(setRouter);
  }, []);

  if (!router) {
    return <Loading height="full" />;
  }

  return (
    <>
      <RouterProvider router={router} />
      <ApiErrorList />
      {loading && <Loading overlay dim />}
    </>
  );
}

export default App;
